import React, { Suspense, useEffect, useState } from "react"
import { LoadingSpinner } from "@kit/design/loading-spinner"
import { useSubscriberProfileId } from "./use-subscriber-profile-id"

const ProfileDrawerPanel = React.lazy(() =>
  import("./components/profile-drawer-panel").then(m => ({
    default: m.ProfileDrawerPanel
  }))
)

// Covers the one-time delay while the drawer chunk downloads, so the first open doesn't look like a no-op.
const PANEL_LOADING_FALLBACK = (
  <div className="fixed inset-0 z-[51] flex items-center justify-center bg-black/70">
    <span role="status" aria-label="Loading subscriber profile">
      <LoadingSpinner className="w-10 h-10 text-white" />
    </span>
  </div>
)

export function SubscriberProfileDrawer() {
  const subscriberProfileId = useSubscriberProfileId()
  const [hasOpenedOnce, setHasOpenedOnce] = useState(false)

  // Latches true on first open and never resets, so later closes don't unmount the panel.
  useEffect(() => {
    if (subscriberProfileId) {
      setHasOpenedOnce(true)
    }
  }, [subscriberProfileId])

  if (!hasOpenedOnce) {
    return null
  }

  // Stays mounted after the first open so ProfileDrawerPanel's own close-transition can play instead of being unmounted mid-animation.
  return (
    <Suspense fallback={PANEL_LOADING_FALLBACK}>
      <ProfileDrawerPanel subscriberProfileId={subscriberProfileId} />
    </Suspense>
  )
}
